import { IsBoolean } from 'class-validator';

export class SliderVisibilityUpdateModel {
  @IsBoolean()
  public visible: boolean;
}
